import React, { useContext, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import "./Guidlines.css";

import { Context } from "../../context/Context";
import { usePageSection } from "../../navigation/pageSections";
import DeliveryAppsGuideline from "./DeliveryAppsGuideline/DeliveryAppsGuideline";
import VideosGuideline from "./VideosGuideline/VideosGuideline";
import { guideFromParams } from "./reportVideoGuide";

const SECTION_COMPONENTS = {
  videos: VideosGuideline,
  payments: DeliveryAppsGuideline,
};

// The section is chosen from the sidebar submenu (`?section=`); sections the
// user may not see (e.g. Delivery Apps for branch users) fall back to Videos.
export const Guidlines = () => {
  const { lang } = useContext(Context);
  const [currentSection, setSection] = usePageSection("guidelines");
  const [params] = useSearchParams();
  const guideKey = params.toString();
  const guide = useMemo(() => guideFromParams(new URLSearchParams(guideKey)), [guideKey]);

  const SectionComponent = SECTION_COMPONENTS[currentSection];

  return (
    <div className={`guidlines-page ${lang === "ar" ? "arabic" : "english"}`}>
      <main className="main">
        <SectionComponent lang={lang} onNavigate={setSection} guide={guide} />
      </main>
    </div>
  );
};
